import React from "react";
import { Flex as RFlex } from "rebass/styled-components";
import BaseComponent from "../Base/BaseComponent";

const Flex = (props) => <BaseComponent data-testid={props.testid} {...props} as={RFlex} />;

export default Flex;
